export default __webpack_public_path__ + "static/media/customer_support_bg.7f3d61f0.png";